import { useMediaQuery, MQ } from "./mediaQueries";

/**
 * Reactive prefers-reduced-motion hook.
 * Phase 7: thin wrapper around the shared `useMediaQuery` primitive
 * so the entire app reads media queries through one centralized,
 * SSR-safe surface.
 */
export function useReducedMotion() {
  return useMediaQuery(MQ.reducedMotion);
}
